import { UPDATE_FLOW_END_SUCCESS, UPDATE_FLOW_END_FAILURE } from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const flowEnd = (state = {}, action) => {
  switch (action.type) {
    // -- UPDATE A FLOW END
    case UPDATE_FLOW_END_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] flowEnd.UPDATE_FLOW_END_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_FLOW_END_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] flowEnd.UPDATE_FLOW_END_SUCCESS()', { state, action })

      return {
        ...state,
        ...action.data
      }
    }

    default:
      return state
  }
}
